import { useState, useEffect } from 'react';
import Header from "./components/Layout/Header";
import Cryptos from "./components/Cryptos/Cryptos";
import CartProvider from "./store/CartProvider";
import Cart from "./components/Cart/Cart";
import ToonBestelling from "./components/Cart/ToonBestelling";

function App() {
  const [cryptos, setCryptos] = useState([]);
  const [cartIsShown, setCartIsShown] = useState(false);

  useEffect(() => {
    const fetchCryptos = async () => {
      console.log("fetchCryptos");
      const response = await fetch(
        "https://www.marchouben.nl/php/crypto-get.php"
      );

      if (!response.ok) {
        throw new Error("Something went wrong!");
      }

      const responseData = await response.json();
      console.log(responseData);
      setCryptos(responseData);
      //console.log(cryptos);
    };

    fetchCryptos().catch((error) => {
      console.log(error.message);
    });
  }, []);

  console.log("*** cryptos ***");
  console.log(cryptos);

  const showCartHandler = () => {
    setCartIsShown(true);
  };

  const hideCartHandler = () => {
    setCartIsShown(false);
  };

  return (
    <CartProvider>
      Crypto order App
      {cartIsShown && <Cart onClose={hideCartHandler} />}
      <Header onShowCart={showCartHandler} />
      <main>
        <Cryptos cryptos={cryptos} />
      </main>
      <ToonBestelling />
    </CartProvider>
  );
}

export default App;